import {useEffect, useState} from "react";
import InputGroup from "./InputGroup";
import {Table} from "omoplay";
import {getSurveyResponses, getSurveyStatistics} from "../../api/project/project.api";
import EChartsReact from "echarts-for-react";
import {pieOption} from "../../constants/chart_config";
import SurveyResponseSheet from "./SurveyResponseSheet";
import SurveyRespondentDemographics from "./SurveyRespondentDemographics";
import {currentQuestionNumbers} from "../../libs/surveyQuestions";

const SurveyStatistics = ({projectId}) => {
    const [surveyStatistics, setSurveyStatistics] = useState([])
    /*
      응답자별 시트 응답(2026-10-06 부터 여기서 한 번만 받는다).
      맨 위 '응답자 성별·연령대' 와 맨 아래 '응답자별 응답' 표가 같은 응답을 쓴다 — 따로 받으면
      그 사이에 새 응답이 들어와 두 곳의 인원이 어긋날 수 있다.
    */
    const [sheet, setSheet] = useState(null)
    const [sheetFailed, setSheetFailed] = useState(false)

    useEffect(() => {
        getSurveyStatistics(projectId).then(({data}) => {
            setSurveyStatistics(data.survey)
        })
    }, [projectId]);

    useEffect(() => {
        let alive = true
        setSheet(null)
        setSheetFailed(false)
        getSurveyResponses(projectId).then(body => {
            if (!alive) return
            const data = body?.data
            // fetch.js 는 실패를 reject 하지 않고 에러 객체를 돌려줄 수 있다 — 모양으로 판정한다.
            if (data && Array.isArray(data.questions) && Array.isArray(data.rows)) setSheet(data)
            else setSheetFailed(true)
        })
        return () => { alive = false }
    }, [projectId]);

    // 문항 제목 앞 자동 순번 — 응답 시트의 현재 문항 순서 기준(시트를 받기 전에는 번호 없이 보인다)
    const numbers = currentQuestionNumbers(sheet?.questions)

    return (
        <div className="flex-col gap-4 bg-white p-4">
            {sheet?.rows?.length > 0 && <SurveyRespondentDemographics rows={sheet.rows} />}
            <div className="flex-col gap-8">
                {
                    surveyStatistics.map(survey => {
                        return (
                            <InputGroup key={`${survey.question}\u0000${survey.type}`}
                                        label={numbers.has(survey.question) ? `${numbers.get(survey.question)} ${survey.question}` : survey.question}>
                                <div className="flex-col gap-4">
                                    <Table headers={[{name: "이름", width: "150px"}, {name: "답변"}]} data={
                                        survey.answers.map(answer => {
                                            return [
                                                <div>{answer.userName}</div>,
                                                <div>{answer.answer}</div>
                                            ]
                                        })
                                    } pagination={{pageSize: 10}}
                                    />
                                    <div className="w-[800px] mt-4">
                                        {
                                            survey.type === "MULTIPLE_CHOICE" && (
                                                <EChartsReact
                                                    option={pieOption(survey.question, survey.answerGroup, "%")}
                                                />
                                            )
                                        }
                                    </div>
                                </div>
                            </InputGroup>
                        )
                    })
                }
                {
                    surveyStatistics.length === 0 && (
                        <div>설문조사가 진행중이지 않습니다.</div>
                    )
                }
            </div>
            <SurveyResponseSheet sheet={sheet} failed={sheetFailed} />
        </div>
    )
}

export default SurveyStatistics
